import React, { useEffect, useRef, useState } from 'react';
import NavBar from '../../../components/NavBar';

const INSUMOS_URL = 'https://api.subhue.org/insumos/';
const MIN_IFRAME_HEIGHT = 480;
const LOAD_TIMEOUT_MS = 20000;

function InsumosPage() {
	const iframeRef = useRef(null);
	const [iframeHeight, setIframeHeight] = useState(MIN_IFRAME_HEIGHT);
	const [isLoading, setIsLoading] = useState(true);
	const [hasError, setHasError] = useState(false);

	useEffect(() => {
		const insumosOrigin = new URL(INSUMOS_URL).origin;

		const timeoutId = setTimeout(() => {
			if (isLoading) {
				setIsLoading(false);
				setHasError(true);
			}
		}, LOAD_TIMEOUT_MS);

		const handleMessage = (event) => {
			if (event.origin !== insumosOrigin) return;

			const data = event.data || {};
			if (
				data.source !== 'subhue' ||
				data.app !== 'timed_insumos' ||
				data.type !== 'timed-insumos:resize'
			) {
				return;
			}

			const height = Math.max(
				MIN_IFRAME_HEIGHT,
				Math.ceil(Number(data.height) || 0),
			);

			setIframeHeight(height);
			setIsLoading(false);
			setHasError(false);
			clearTimeout(timeoutId);
		};

		window.addEventListener('message', handleMessage);

		return () => {
			clearTimeout(timeoutId);
			window.removeEventListener('message', handleMessage);
		};
	}, [isLoading]);

	const handleIframeLoad = () => {
		setIsLoading(false);
		setHasError(false);
	};

	return (
		<div className='flex min-h-screen flex-col bg-[#F0F4F8]'>
			<NavBar />

			<div className='mt-[80px] bg-[#F0F4F8] px-6 py-[36px] text-center font-inter text-[26px] font-semibold text-[#13335A] sm:text-[28px]'>
				Insumos TIMED
			</div>

			<main className='relative flex-1 bg-white'>
				{isLoading && (
					<div className='absolute inset-0 z-20 flex min-h-[480px] items-center justify-center bg-white'>
						<div className='h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-gray-700' />
					</div>
				)}

				{hasError && (
					<div className='flex min-h-[480px] items-center justify-center px-6 text-center'>
						<p className='max-w-md text-[18px] font-medium text-gray-700'>
							O relatório não pôde ser carregado. Tente novamente
							mais tarde.
						</p>
					</div>
				)}

				{!hasError && (
					<iframe
						ref={iframeRef}
						id='insumos-frame'
						src={INSUMOS_URL}
						title='Insumos'
						onLoad={handleIframeLoad}
						style={{
							width: '100%',
							minHeight: `${MIN_IFRAME_HEIGHT}px`,
							height: `${iframeHeight}px`,
							border: 0,
							display: 'block',
						}}
					/>
				)}
			</main>
		</div>
	);
}

export default InsumosPage;
